import * as React from "react";
import {Tooltip} from "react-tooltip";
import {Box, Grid, useMediaQuery} from "@mui/material";

import Map from "./Map/Map";
import {ImpactBoxes} from "./ImpactBoxes/ImpactBoxes";
import {DownloadButtons} from "./DownloadButtons/DownloadButtons";

import theme from "../../../components/styles/theme/theme";

interface StatisticsProps {
  printRef: React.RefObject<HTMLElement>;
}

export const Statistics: React.FC<StatisticsProps> = ({printRef}) => {
  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isXlScreen = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <>
      <Box
        sx={{flexGrow: 1, display: "flex"}}
        padding={`25px ${isXlScreen ? "100px" : "25px"} 25px 25px`}
        id="statistics-box"
      >
          <div id="stats-container" style={{
            width: "50%",
            margin: "auto"
          }}>
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              lg={1}
              order={{xs: 2, md: 2, lg: 1}}
            >
              <ImpactBoxes/>
              <Box
                gridColumn="span 12"
                display="flex"
                gap="15px"
                alignItems="center"
                flexDirection={isSmScreen ? "column" : "row"}
                paddingTop="16px"
              >
                <DownloadButtons printRef={printRef}/>
              </Box>
            </Grid>
          </div>
          <div style={{
            width: "50%",
              height: "100%"
          }}
               className='hidden-print'
          >
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              lg={1}
              order={{xs: 1, md: 1, lg: 2}}
            >
              <Map/>
              <Tooltip
                id="my-tooltip"
                variant={"light"}
                classNameArrow="tooltip-arrow"
                style={{
                  zIndex: 2,
                  border: `1px solid ${theme.palette.primary.light}`,
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.4)",
                }}
              />
            </Grid>
          </div>

      </Box>
    </>
  );
};
